const initTohfaReveal = (root = document) => {
  const items = root.querySelectorAll('.tohfa-category, .tohfa-product-cell, .tohfa-trust__item, .tohfa-review, .tohfa-faq__item, .tohfa-story__media, .tohfa-story__content, .tohfa-marquee__item, .tohfa-content-page .page-width');
  items.forEach((item) => item.classList.add('tohfa-reveal'));
  if (!('IntersectionObserver' in window)) { items.forEach((item) => item.classList.add('is-visible')); return; }
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
  }), { threshold: 0.12, rootMargin: '0px 0px -30px' });
  items.forEach((item) => observer.observe(item));
};

const initTohfaSliders = (root = document) => {
  root.querySelectorAll('[data-tohfa-slider]').forEach((slider) => {
    if (slider.dataset.sliderReady === 'true') return;
    slider.dataset.sliderReady = 'true';
    const slides = [...slider.querySelectorAll('[data-slide-index]')];
    const buttons = [...slider.querySelectorAll('[data-slide-button]')];
    if (slides.length < 2) return;
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;
    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === activeIndex;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
      buttons.forEach((button, buttonIndex) => {
        const selected = buttonIndex === activeIndex;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(activeIndex + 1), Number(slider.dataset.interval) || 7000);
      }
    };
    buttons.forEach((button) => button.addEventListener('click', () => { show(Number(button.dataset.slideButton)); start(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    start();
  });
};

document.addEventListener('DOMContentLoaded', () => { initTohfaReveal(); initTohfaSliders(); });
document.addEventListener('shopify:section:load', (event) => { initTohfaReveal(event.target); initTohfaSliders(event.target); });
